import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/Agency.css"; // Import custom CSS

export default function Agency(props) {
  const [formData, setFormData] = useState({
    username: "",
    typeapp: "",
    commission_app: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [typeAppOptions, setTypeAppOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [commissionData, setCommissionData] = useState([]);
  const [searchUsername, setSearchUsername] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [treeData, setTreeData] = useState({});
  const [treeLoading, setTreeLoading] = useState(true);
  const [treeError, setTreeError] = useState(null);
  const [treeSearchUsername, setTreeSearchUsername] = useState("");
  const [expandedParents, setExpandedParents] = useState({}); // State to manage collapsible sections

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          typeAppsRes,
          usersRes,
          commissionsRes,
          treeRes,
        ] = await Promise.all([
          axios.get(`${API_BASE_URL}/allapp`),
          axios.get(`${API_BASE_URL}/get_all_info`),
          axios.get(`${API_BASE_URL}/get_all_commissions`),
          axios.get(`${API_BASE_URL}/accounts/tree`),
        ]);

        setTypeAppOptions(typeAppsRes.data);

        if (usersRes.data && usersRes.data.infos) {
          const formattedUsers = usersRes.data.infos.map((user) => ({
            value: user.UserName,
            label: user.UserName,
          }));
          setUserOptions(formattedUsers);
        }

        setCommissionData(commissionsRes.data);
        setTreeData(treeRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setResponseMessage("Error: Could not fetch data.");
        if (error.config.url.includes("tree")) {
          setTreeError("Failed to load agency tree.");
        }
      } finally {
        setTreeLoading(false);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = isEditMode
      ? `${API_BASE_URL}/update_price_commission`
      : `${API_BASE_URL}/add_commission`;

    try {
      const response = await axios.post(url, formData);
      setResponseMessage(`Success: ${response.data.message}`);
      setFormData({ username: "", typeapp: "", commission_app: "" });
      setIsEditMode(false);
      // Refresh commissions data
      const commissionsRes = await axios.get(`${API_BASE_URL}/get_all_commissions`);
      setCommissionData(commissionsRes.data);
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Could not connect to the server.";
      setResponseMessage(`Error: ${errorMsg}`);
      console.error("Error submitting form:", error);
    }
  };

  const handleEdit = (commission) => {
    setFormData({
      username: commission.UserName,
      typeapp: commission.Type_App,
      commission_app: commission.commission_App,
    });
    setIsEditMode(true);
    window.scrollTo(0, 0); // Scroll to top to see the form
  };

  const toggleParent = (parent) => {
    setExpandedParents(prev => ({
      ...prev,
      [parent]: !prev[parent]
    }));
  };

  const filteredCommissions = commissionData.filter((commission) =>
    commission.UserName.toLowerCase().includes(searchUsername.toLowerCase())
  );

  const filteredTreeData = Object.entries(treeData).filter(([parent]) =>
    parent.toLowerCase().includes(treeSearchUsername.toLowerCase())
  );

  return (
    <div className="container-fluid agency-page">
      <div className="row">
        {/* Left Column: Form and Commission Table */}
        <div className="col-lg-7">
          {/* Form Card */}
          <div className="card shadow-sm mb-4">
            <div className="card-header-custom">
              <h3>{isEditMode ? "Chỉnh sửa hoa hồng" : "Thêm hoa hồng"}</h3>
            </div>
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="username" className="form-label fw-bold">Username</label>
                  <Select
                    id="username"
                    name="username"
                    options={userOptions}
                    value={userOptions.find((option) => option.value === formData.username) || null}
                    onChange={(selectedOption) => handleChange("username", selectedOption?.value || "")}
                    placeholder="Chọn hoặc tìm kiếm user..."
                    isClearable
                    required
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="typeapp" className="form-label fw-bold">Loại App</label>
                  <select id="typeapp" name="typeapp" value={formData.typeapp} onChange={(e) => handleChange("typeapp", e.target.value)} className="form-select" required>
                    <option value="">Chọn loại app</option>
                    {typeAppOptions.map((app) => (
                      <option key={app.Id_app} value={app.Id_app}>{app.Name_app}</option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label htmlFor="commission_app" className="form-label fw-bold">Hoa hồng (%)</label>
                  <input type="number" id="commission_app" name="commission_app" value={formData.commission_app} onChange={(e) => handleChange("commission_app", e.target.value)} className="form-control" placeholder="Nhập phần trăm hoa hồng" step="0.01" min="0" max="100" required />
                </div>
                <div className="d-grid">
                  <button type="submit" className="btn btn-primary btn-lg">
                    {isEditMode ? "Cập nhật" : "Thêm mới"}
                  </button>
                </div>
              </form>
              {responseMessage && (
                <div className={`mt-3 alert ${responseMessage.startsWith("Error") ? "alert-danger" : "alert-success"}`}>
                  {responseMessage}
                </div>
              )}
            </div>
          </div>

          {/* Commission Table Card */}
          <div className="card shadow-sm">
            <div className="card-header-custom">
              <h3>Dữ liệu hoa hồng</h3>
              <input type="text" className="form-control form-control-sm" placeholder="Tìm theo username..." value={searchUsername} onChange={(e) => setSearchUsername(e.target.value)} />
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th scope="col">Username</th>
                      <th scope="col">Loại App</th>
                      <th scope="col">Hoa hồng (%)</th>
                      <th scope="col">Hành động</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredCommissions.length > 0 ? (
                      filteredCommissions.map((commission, index) => (
                        <tr key={index}>
                          <td>{commission.UserName}</td>
                          <td>{commission.Type_App}</td>
                          <td>{commission.commission_App}%</td>
                          <td>
                            <button className="btn btn-sm btn-edit" onClick={() => handleEdit(commission)}>
                              Sửa
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center p-4">Không tìm thấy dữ liệu.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Agency Tree */}
        <div className="col-lg-5">
          <div className="card shadow-sm agency-tree">
            <div className="card-header-custom">
              <h3>Hệ thống đại lý</h3>
              <input type="text" className="form-control form-control-sm" placeholder="Tìm đại lý..." value={treeSearchUsername} onChange={(e) => setTreeSearchUsername(e.target.value)} />
            </div>
            <div className="card-body p-0">
              {treeLoading ? (
                <div className="text-center p-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
              ) : treeError ? (
                <div className="alert alert-danger m-3">{treeError}</div>
              ) : filteredTreeData.length > 0 ? (
                <ul className="list-group list-group-flush">
                  {filteredTreeData.map(([parent, children]) => (
                    <li key={parent} className="list-group-item">
                      <div className="d-flex w-100 justify-content-between align-items-center" onClick={() => children.length > 0 && toggleParent(parent)} style={{ cursor: children.length > 0 ? 'pointer' : 'default' }}>
                        <h5 className="mb-0">{parent}</h5>
                        <div>
                          <span className="badge bg-primary rounded-pill me-2">{children.length}</span>
                          {children.length > 0 && (
                            <span className="fw-bold">{expandedParents[parent] ? '▼' : '►'}</span>
                          )}
                        </div>
                      </div>
                      {expandedParents[parent] && children.length > 0 && (
                        <ul className="list-unstyled mt-2 ps-3">
                          {children.map((child) => (
                            <li key={child} className="text-muted py-1">
                              - {child}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-center p-4">Không có dữ liệu đại lý.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}